import axios from 'axios'

import { cleanBlankValue, openNewTabBlobFile } from 'utils/helper'

export const getFinanceBankTranses = (params) => {
  return axios.get('/finance/bankTrans', { params })
}

export const getTotalFinanceBankTrans = (params) => {
  return axios.get('/finance/bankTrans/totals', { params })
}

export const getFinanceBankTrans = (id) => {
  return axios.get(`/finance/bankTrans/${id}`)
}

export const getFinanceBankTransLog = ({ id, params } = {}) => {
  return axios.get(`/finance/bankTrans/${id}/logs`, { params })
}

export const editFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}`, data)
}

export const purchasePaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/purchasePayment', data)
}

export const joinedPurchasePaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/joinedPurchaseInvoicePayment', data)
}

export const editJoinedPurchaseInvoicePaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/joinedPurchaseInvoicePayment`, data)
}

export const invoicePaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/invoicePayment', data)
}

export const orderPaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/orderPayment', data)
}

export const purchaseOrderPaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/purchaseOrderPayment', data)
}

export const creditMemoPaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/creditMemoPayment', data)
}

export const debitMemoPaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/debitMemoPayment', data)
}

export const deleteOnAddFinanceBankTransAttachment = (url) => {
  return axios.delete('/finance/bankTrans/attachments', { data: { url } })
}

export const deleteOnEditFinanceBankTransAttachment = (id, url) => {
  return axios.delete(`/finance/bankTrans/${id}/attachments`, { data: { url } })
}

export const deleteFinanceBankTrans = (id) => {
  return axios.delete(`/finance/bankTrans/${id}`)
}

export const deleteFinanceBankTransWithReason = (id, data, config = {}) => {
  return axios.delete(`/finance/bankTrans/${id}`, { data, ...config })
}

export const transferFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/transfer', data)
}

export const spendFinanceBankTrans = (data, config = {}) => {
  return axios.post('/finance/bankTrans/spend', data, config)
}

export const receiveFinanceBankTrans = (data, config = {}) => {
  return axios.post('/finance/bankTrans/receive', data, config)
}

export const deleteTransferFinanceBankTrans = (id) => {
  return axios.delete(`/finance/bankTrans/${id}/transfer`)
}

export const editTransferFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/transfer`, data)
}

export const expensePaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/expensePayment', data)
}

export const editPurchasePaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/purchasePayment`, data)
}

export const editInvoicePaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/invoicePayment`, data)
}

export const editExpensePaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/expensePayment`, data)
}

export const editCreditMemoPaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/creditMemoPayment`, data)
}

export const editDebitMemoPaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/debitMemoPayment`, data)
}

export const editOrderPaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/orderPayment`, data)
}

export const editPurchaseOrderPaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/purchaseOrderPayment`, data)
}

export const createPdfFinanceBankTrans = (id) => {
  return axios
    .get(`/finance/bankTrans/${id}/print`, { responseType: 'blob' })
    .then((response) => {
      openNewTabBlobFile(response)
      return Promise.resolve(true)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

export const getFinanceBankTransPublicUrl = (id) => {
  return axios.get(`/finance/bankTrans/${id}/publicUrl`)
}

export const exportFinanceBankTrans = (params) => {
  params = cleanBlankValue(params)
  return axios.get('/finance/bankTrans/export', { responseType: 'arraybuffer', params })
}

export const getFinanceBankTransWaTemplate = (id) => {
  return axios.get(`/finance/bankTrans/${id}/whatsapp`)
}

export const getFinanceBankTransInputWhatsappTemplate = (id) => {
  return axios.get(`/finance/bankTrans/${id}/inputWhatsapp`)
}

export const sendFinanceBankTransWhatsapp = (payload) => {
  const { id, ...body } = payload
  return axios.post(`/finance/bankTrans/${id}/whatsapp`, body)
}

export const getFinanceBankTransEmailTemplate = (id) => {
  return axios.get(`/finance/bankTrans/${id}/email`)
}

export const sendFinanceBankTransEmail = (id, data) => {
  return axios.post(`/finance/bankTrans/${id}/email`, data)
}

export const addRecurringBankTrans = (data) => {
  return axios.post('/finance/bankTrans/recurring', data)
}

export const editRecurringBankTrans = (data) => {
  return axios.put(`/finance/bankTrans/recurring/${data.id}`, data)
}

export const getRecurringBankTrans = (id) => {
  return axios.get(`/finance/bankTrans/recurring/${id}`)
}

export const deleteRecurringBankTrans = (id) => {
  return axios.delete(`/finance/bankTrans/recurring/${id}`)
}

export const getRecurringBankTranses = (params) => {
  return axios.get(`/finance/bankTrans/recurring`, { params })
}

export const getFinanceBankTransSmsTemplate = (id) => {
  return axios.get(`/finance/bankTrans/${id}/sms`)
}

export const sendFinanceBankTransSms = (id, data) => {
  return axios.post(`/finance/bankTrans/${id}/sms`, data)
}

export const inputMassDeleteFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/inputMassDelete', data)
}

export const executeMassDeleteFinanceBankTrans = (data) => {
  return axios.delete('/finance/bankTrans/executeMassDelete', { data })
}

export const uploadImportFinanceBankTrans = (data) => {
  return axios.postForm('/finance/bankTrans/uploadImport', data)
}

export const executeImportFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/executeImport', data)
}

export const massPaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/massPayment', data)
}

export const executeMassPaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/executeMassPayment', data)
}

export const uploadImportFinanceBankTransfer = (data) => {
  return axios.postForm('/finance/bankTrans/transfer/uploadImport', data)
}

export const executeImportFinanceBankTransfer = (data) => {
  return axios.post('/finance/bankTrans/transfer/executeImport', data)
}

export const approveFinanceBankTransfer = (id) => {
  return axios.post(`finance/bankTrans/${id}/approve`)
}

export const rejectFinanceBankTransfer = ({ id, body }) => {
  return axios.post(`finance/bankTrans/${id}/reject`, body)
}

export const revertFinanceBankTransfer = ({ id }) => {
  return axios.post(`finance/bankTrans/${id}/revert`)
}

export const joinedInvoicePaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/joinedSalesInvoicePayment', data)
}

export const editJoinedInvoicePaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/joinedSalesInvoicePayment`, data)
}

export const multiInvoicePaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/multiInvoicePayment', data)
}

export const editMultiInvoicePaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/multiInvoicePayment`, data)
}

export const multiPurchasePaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/multiPurchasePayment', data)
}

export const editMultiPurchasePaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/multiPurchasePayment`, data)
}

export const proformaPaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/proformaPayment', data)
}

export const proformaOrderPaymentFinanceBankTrans = (data) => {
  return axios.post('/finance/bankTrans/proformaOrderPayment', data)
}

export const editProformaPaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/proformaPayment`, data)
}

export const editProformaOrderPaymentFinanceBankTrans = (id, data) => {
  return axios.put(`/finance/bankTrans/${id}/proformaOrderPayment`, data)
}

export const inputMassReconcileFinanceBankTrans = (data) => {
  return axios.post('/finance/bankReconciles/inputMassForceReconcile', data)
}

export const executeMassReconcileFinanceBankTrans = (data) => {
  return axios.post('/finance/bankReconciles/executeMassForceReconcile', data)
}
